import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);

    this.$el = this.el;
    this.$items = this.$('item');

    // Bind
    this.onMouseMove = this.onMouseMove.bind(this);
    this.rafId = null;
    this.lastEvent = null;

    this.isDesktop = window.innerWidth >= 1024; // брейкпоинт можно изменить
  }

  init() {
    if (this.isDesktop) {
      this.bindEvents();
    }
  }

  onMouseMove(e) {
    this.lastEvent = e;

    if (!this.rafId) {
      this.rafId = requestAnimationFrame(() => {
        this.updateRotation();
        this.rafId = null;
      });
    }
  }

  updateRotation() {
    if (!this.lastEvent) return;

    const { clientX, clientY } = this.lastEvent;

    this.$items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const itemX = rect.left + rect.width / 2;
      const itemY = rect.top + rect.height / 2;

      const deltaX = clientX - itemX;
      const deltaY = clientY - itemY;
      const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);

      item.style.transform = `rotate(${angle + 90}deg)`;
    });
  }

  bindEvents() {
    window.addEventListener('mousemove', this.onMouseMove);
  }

  unbindEvents() {
    window.removeEventListener('mousemove', this.onMouseMove);
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  }

  destroy() {
    super.destroy();
    this.unbindEvents();
  }
}